<template>
  <v-container>
    <v-row no-gutters>
      <v-col md="6" offset-md="3">
        <v-alert outlined prominent color="blue" v-html="message"> </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  VERIFY_REGISTER,
  SET_AUTH_DATA,
  PURGE_AUTH
} from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "verifyRegister",
  data(){
    return {
      message: "กำลังทำการตรวจสอบ ..."
    };
  },
  mounted() {
    this.verifyRegister(this.$route.query.code);
  },
  methods: {
    verifyRegister(code) {
      this.$store.commit(PURGE_AUTH);
      this.$store
        .dispatch(VERIFY_REGISTER, { code })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            if(data.data.message === 'VERIFY_SUCCESS'){
              this.message = `ยืนยันตัวตนเสร็จเรียบร้อย`;
              this.$store.commit(SET_AUTH_DATA, data.data.data);
              setTimeout(() => {
                this.$router.push("/");
              }, 2000);
            } else if (data.data.message === "ALREADY_EXIST") {
              this.message = `
                รหัสของคุณมีการยืนยันตัวตนเรียบร้อยแล้ว <br/>
                <a href="#/login">กลับไปหน้า login</a>
              `;
            } else {
              this.message = `
                ระบบเกิดข้อผิดพลาด กรุณาตรวจสอบใหม่อีกครั้ง <br/>
                <a href="#/login">กลับไปหน้า login</a>
              `;
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    }
  }
};
</script>

<style></style>
